module.exports = __webpack_public_path__ + "img/header-diamondJewelryBracelets@2x.47f1ead.jpg";